import { useEffect, useState } from 'react';

type WindowSizes = {
  width: number;
  height: number;
  ratio: number;
};

export const useWindowSizes = (): WindowSizes => {
  const [sizes, setSizes] = useState<WindowSizes>({
    width: 0,
    height: 0,
    ratio: 0
  });

  useEffect(() => {
    const handleResize = () => {
      setSizes({
        width: window.innerWidth,
        height: window.innerHeight,
        ratio: window.innerWidth / window.innerHeight
      });
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return sizes;
};
